import { Box, Container } from "@mui/material"
import riteDashboard from "../../../assets/imgs/Dashboards/riteCharleeDashboard.png"
import patterns from "../../../assets/imgs/pattens/Path.png"

export const RiteCharleeDashboard = () => {
  return (
    <Box className="w-full relative">
      <div
        className="h-[400px] w-full absolute top-[50%]"
        role="presentation"
        aria-hidden="true"
        style={{ background: `url(${patterns})`, backgroundRepeat: "repeat-x", transform: "translateY(-50%)" }}
      />
      <Container maxWidth="lg">
        <Box
          className="riteCharlee-board w-full relative rounded-xl overflow-hidden"
          role="img"
          aria-label="RiteCharlee risk intelligence dashboard with underwriting benchmarks"
          sx={{ background: `url(${riteDashboard})`, backgroundRepeat: "no-repeat", backgroundSize: "110%", backgroundPosition: "center" }}
        >
          <img src={riteDashboard} alt="RiteCharlee risk intelligence dashboard for underwriting teams" className="hidden md:block w-full mx-auto opacity-0" style={{ maxWidth: "100vw" }} width={1200} height={700} loading="lazy" />
          <img src={riteDashboard} alt="RiteCharlee risk intelligence dashboard on mobile" className="block md:hidden w-[130vw] mx-auto" style={{ maxWidth: "200vw", transform: "translate(-18vw, 0)" }} width={800} height={500} loading="lazy" />
        </Box>
      </Container>
    </Box>
  )
}
